
    import {defineComponent, toRefs, reactive, watch} from 'vue';
    import {useRoute} from "vue-router";

    interface State {
        title: string;
        data: object;
        text: string;
        listSumNumber: number;
        isShowModel: boolean;
        channelType: string;
    }

    export default defineComponent({
        name: "componentTitle",
        props: {
            title: {
                type: String,
                default: '',
            },
            data: {
                type: Object,
                default: () => {
                    return {}
                },
            },
            listSumNumber: {
                type: Number,
                default: 0
            }
        },
        setup(props: any) {
            let state: State = reactive({
                title: '',
                data: {},
                text: '',
                listSumNumber: 0,
                isShowModel: false,
                channelType: '',
            })
            const {query} = useRoute();
            const {title, data, listSumNumber} = toRefs(props);
            state.channelType = `${query.channelType}` || '';
            state.title = title.value;
            state.data = data.value;
            watch(listSumNumber, (listSumNumber: number) => {
                state.listSumNumber = listSumNumber
            })
            return {
                state
            }
        },
        methods: {
            clickFun() {
                let clickFun = (this.state.data as any).clickFun
                this[clickFun]()
            },
            showRemind() {
                let modelCnt = (this.state.data as any).modelCnt;
                this.state.text = modelCnt;
                this.state.isShowModel = true;
                document.body.style.overflow = "hidden";
            },
            hiddenModel(){
                this.state.isShowModel = false
                document.body.style.overflow = "" 
            }
        }
    })
